define([
    './ModalService',
    './ModalCtrl',
    './ModalProvider',

    './dataStructures/StackedMap',
    './dataStructures/ModalStack',

    './directives/ModalBackdrop',
    './directives/ModalWindow',
    '../../../quoteandbind/common/services/LoadSaveService',// Eodb membership detail popup--Arpita Sengupta
    '../../../../../../../app/customer/js/src/edge/policyjob/services/MembershipService.js'// Eodb membership detail popup--Arpita Sengupta
], (ModalService, ModalController, ModalProvider, StackedMap, ModalStack, ModalBackdropDirective, ModalWindowDirective,LoadSaveService,MembershipService)=> {
    return angular.module('edge.platform.widgets.modal', [])
        .factory('$$stackedMap', StackedMap) //Internal data structure
        .factory('$modalStack', ModalStack)  //Internal data structure
        .provider('$modal', ModalProvider)
        .factory('ModalService', ModalService)
        .controller('ModalController', ModalController)
        .directive('modalBackdrop', ModalBackdropDirective) //A helper directive for the $modal service. It creates a backdrop element.
        .directive('modalWindow', ModalWindowDirective)
        .factory('LoadSaveService', LoadSaveService)// Eodb membership detail popup--Arpita Sengupta
        .factory('MembershipService', MembershipService);// Eodb membership detail popup--Arpita Sengupta
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/modal/module.js
 **/